export enum ItemTypeEnum {
  CHIP = 'chip',
  SWATCH = 'swatch',
  PART = 'part',
  COLOUR_STYLE = 'colour_style',
  DECAL = 'decal',
  MOD = 'mod',
  TRAIL = 'trail',
  RESPAWN_DRONE = 'respawn_drone',
  CORE_STYLE = 'core_style',
  BOOST = 'boost',
  CURRENCY = 'currency',
  HAT = 'hat'
}
